import Query from '../../../../components/Report';

export const query = ({ position_start = 6, position_end = 20 }) =>
    new Query('opportunities-search-striking-distance', {
        position_start,
        position_end,
    });
